import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { teamValues } from '@/mocks/strategix';

export default function TeamValues() {
  return (
    <section className="relative w-full px-5 md:px-10 pb-20 md:pb-28">
      <div className="max-w-6xl mx-auto">
        <div className="rounded-lg bg-background-100/60 border border-background-200/70 p-8 md:p-12">
          <SectionHeading
            label="Как мы работаем"
            title="Принципы нашей команды"
            description="Небольшая, но слаженная команда — залог стабильного результата без «размытой» ответственности."
          />

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {teamValues.map((value, index) => (
              <Reveal key={value.title} delay={index * 80} className="h-full">
                <div className="h-full flex flex-col p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-300">
                    <i className={`${value.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base text-foreground-950">{value.title}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{value.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}